export default "__VITE_ASSET__d9df1b15__"